module.exports = __webpack_public_path__ + "images/rbl_header_logo74db139cb0df036b490487b3bcbc012c.svg";